/**
 * Emulation endpoints.
 */
export interface IEmulationEndpoints {
  getEnabled: () => string;
  searchUsers: (search: string) => string;
  getProfile: (userId: string) => string;
}

/**
 * Emulation endpoints factory.
 * @param versionedUrl The versioned API base url.
 */
export const emulationEndpoints = (versionedUrl: string): IEmulationEndpoints => {
  const baseUrl = `${versionedUrl}emulation`;

  return {
    getEnabled: () => `${baseUrl}/enabled`,
    searchUsers: (search: string) => `${baseUrl}/users?search=${encodeURIComponent(search)}`,
    getProfile: (userId: string) => `${baseUrl}/profile/${userId}`,
  };
};
